var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      ref: "drawer",
      attrs: {
        title: _vm.$t("Menu.SettingsAndTools"),
        visible: _vm.innerVisible,
        size: "36%",
        "custom-class": "setting-and-tools-drawer",
        modal: false,
        "append-to-body": ""
      },
      on: { close: _vm.handleClose }
    },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("Tool.UserInfo"), name: "personalInfo" } },
            [_c("personal-info-form", { ref: "personalInfo" })],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("Tool.Individual"),
                name: "personalization",
                lazy: ""
              }
            },
            [_c("page-personalization", { ref: "personal" })],
            1
          ),
          _vm.isAdmin || _vm.isDelegation || (!_vm.isAdmin && !_vm.isDelegation)
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Tool.Authorize"),
                    name: "delegate",
                    lazy: ""
                  }
                },
                [
                  _c("delegate-info-form", {
                    attrs: { "is-delegation": _vm.isDelegation },
                    on: {
                      "update:isDelegation": function($event) {
                        _vm.isDelegation = $event
                      },
                      "update:is-delegation": function($event) {
                        _vm.isDelegation = $event
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }